/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {Meta} from '@/decorators';
import {MetaInfo} from 'vue-meta';
import ReportedIssuesGame from '@/views/ReportedIssuesGame/index.vue';
import ReportedIssuesGameSelect from '@/views/ReportedIssuesGameSelect/index.vue';

@Component({
    name: 'v-reported-issues',
    components: {
        'c-game-select': ReportedIssuesGameSelect,
        'c-game-issues': ReportedIssuesGame,
    },
})

export default class ReportedIssues extends Vue {
    // Page Title
    @Action('updatePageTitle', {namespace: 'settingsModule'})
    public updatePageTitle!: (title: string) => void;

    // Update current view name in state
    @Action('updateCurrentView', {namespace: 'userSessionModule'})
    public updateCurrentView!: (view: {name: string, params?: any} | undefined) => void;

    /**
     * Mounted life-cycle event.
     *
     * Initialises the loader.
     */
    public async mounted(): Promise<void> {
        // Set the page title
        this.updatePageTitle(this.$i18n.translate('menu.header.reportedIssues', {}) || '');

        // Update current view name in state
        this.updateCurrentView({
            name: this.$router.currentRoute.name || 'home',
            params: this.$router.currentRoute.params || undefined,
        });
    }

    /**
     * Meta generation.
     *
     * This is an example cascaded meta generator for title and other met properties.
     *
     * @returns {MetaInfo}
     */
    @Meta
    public meta(): MetaInfo {
        const title: string = 'Reported Issues';

        return {
            title,
            meta: [
                {
                    property: 'og:title',
                    content: `${this.$i18n.translate('application.title', {}) || ''} - ${title}`,
                },
                {
                    property: 'og:description',
                    content: 'View reported Issues',
                },
                {
                    property: 'og:image',
                    content: window.location.hostname + '/img/og_image.jpg',
                },
            ],
        };
    }
}
